import _L from "../../../util/Labels";
import { _AgregarEventos, _EditarEvento, _ObtenerConfiguracionInfo } from "../../../data/modulo/EventoCalendario";
import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { _ModalConfirmacionBasicoV2 } from "../../controlD3/ModalThings/ModalConfirmacionBasicoV2";
import { CalendarioGridV2 } from "../../controlD3/CalendarioGrid/CalendarioGridV2";
import { DataModuloMain } from "../../../data/ModuloMain";
import { DateV2 } from "../../../util/DateV2";
import { Entidad } from "../../../data/Entidad";
import { FormGenerator, IAtributosSelectMaterial } from "../../controlD3/Formulario";
import { ICalendariosToSend, IEventForm } from "../../../data/entidad/Calendario";
import { InputDatePicker } from "../../controlD3/InputDatePicker";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { SelectV2 } from "../../controlD3/SelectV2";
import { UIUtilPermission } from "../../util/Permission";
import { UIUtilTime } from "../../util/Time";
import { UIUtilViewData } from "../../util/ViewData";

import CCalendarioFinRecurrencia = Entidad.CCalendarioFinRecurrencia;
import CCalendarioTipoEntidad = Entidad.CCalendarioTipoEntidad;
import CCalendarioTipoRecurrencia = Entidad.CCalendarioTipoRecurrencia;
import CCalendarioTipoRecurrenciaMensual = Entidad.CCalendarioTipoRecurrenciaMensual;
import CTipoAccionEvento = Entidad.CTipoAccionEvento
import ICalendario = Entidad.ICalendario
import IEventoInfo = Entidad.IEventoInfo;
import IEventoPorCalendario = Entidad.IEventoPorCalendario

const ModuloCalendario = Entidad.CModulo.Calendarios

export namespace UIUtilViewCalendario {
    const TIME_ZERO_STR = " 00:00";

    const ORDINAL_NUMBERS: { [k in number]: string } = {
        1: _L("calendario.ord_first"),
        2: _L("calendario.ord_second"),
        3: _L("calendario.ord_third"),
        4: _L("calendario.ord_fourth")
    }

    function GetEventFreeRecStartDate(fechasPersonalizadas: string[], eventStartDate: Date) {
        let customDtsToValidate = fechasPersonalizadas.map(d => UIUtilTime._FmtToInputDate(d)).sort();
        let startDtToValidate = eventStartDate ? UIUtilTime._FmtToInputDate(eventStartDate) : null;

        return (
            customDtsToValidate.includes(startDtToValidate)
                ? startDtToValidate
                : customDtsToValidate[0]
        )
    }

    function GetStartAndEndDate({ IsAllDay, FechaInicioYMD, FechaUnicaYMD, HoraInicioHM, HoraFinHM, TipoRecurrencia, FechasPersonalizadas }: IEventForm, startDate?: Date) {

        let startDateinputFmt = TipoRecurrencia == CCalendarioTipoRecurrencia.Libre
            ? GetEventFreeRecStartDate(FechasPersonalizadas, startDate)
            : IsAllDay
                ? FechaInicioYMD
                : FechaUnicaYMD


        let strInitDate = IsAllDay
            ? `${startDateinputFmt + TIME_ZERO_STR}`
            : `${startDateinputFmt} ${HoraInicioHM}`;
        let dtInicio = new Date(strInitDate);

        let strEndDate = IsAllDay
            ? `${startDateinputFmt + TIME_ZERO_STR}`
            : `${startDateinputFmt} ${HoraFinHM}`;
        let dtFin = new Date(strEndDate);
        IsAllDay && (dtFin.setDate(dtFin.getDate() + 1));

        return { dtInicio, dtFin }
    }

    function GetCalendarInfoToSend(calendar: ICalendario): ICalendariosToSend {
        return {
            IdCalendario: calendar.Id,
            IdKinder: calendar.IdEscuela,
            IdEscolaridad: calendar.IdEscolaridad,
            IdGrupo: calendar.TipoEntidad == CCalendarioTipoEntidad.Grupo ? calendar.IdEntidad : 0,
            TipoEvento: calendar.TipoEntidad == CCalendarioTipoEntidad.Alimento ? -1 : calendar.TipoEntidad,
            IdEntidad: calendar.IdEntidad
        }
    }

    function GetRecurrenceInfo({ IsAllDay, HoraInicioHM, TipoRecurrencia, TipoFinRecurrencia, NRecurrencias, FechaFinRecurrenciaYMD, VarianteRecurrencia, FechasPersonalizadas }: IEventForm) {
        let isRecurrent = ![CCalendarioTipoRecurrencia.SinRecurrencia, CCalendarioTipoRecurrencia.Libre].includes(TipoRecurrencia);

        let varianteRecurrencia = (TipoRecurrencia == CCalendarioTipoRecurrencia.Mensual)
            ? VarianteRecurrencia
            : CCalendarioTipoRecurrenciaMensual.NoAplica;

        let tipoFinRecurrencia = (isRecurrent)
            ? TipoFinRecurrencia
            : 0;

        let nRecurrencias = (isRecurrent && TipoFinRecurrencia == CCalendarioFinRecurrencia.Numero)
            ? NRecurrencias
            : 0;

        let fechaFinRecurrencia = (isRecurrent && TipoFinRecurrencia == CCalendarioFinRecurrencia.Fecha)
            ? new DateV2(`${FechaFinRecurrenciaYMD} ${IsAllDay ? '00:00' : HoraInicioHM}`)._ToISOLocalString()
            : null;

        let fechasPersonalizadas = (TipoRecurrencia == CCalendarioTipoRecurrencia.Libre)
            ? FechasPersonalizadas.map(d => new DateV2(d)._ToISOLocalString())
            : null;

        return {
            varianteRecurrencia,
            tipoFinRecurrencia,
            fechaFinRecurrencia,
            nRecurrencias,
            fechasPersonalizadas
        }
    }

    function EvalCustomDtsChanged(customDtsOrigin: string[], customDts: string[]): boolean {
        if (customDtsOrigin.length !== customDts.length) return true;

        const newCustomDatesMap = new Map(customDts.map(d => {
            let fmtInputDate = UIUtilTime._FmtToInputDate(new Date(d));
            return [fmtInputDate, fmtInputDate]
        }))

        return customDtsOrigin.some(customDt => !newCustomDatesMap.get(UIUtilTime._FmtToInputDate(new Date(customDt))))
    }

    function GetEditionOptions(
        { IdCalendarios, TipoRecurrencia, FechasPersonalizadas }: IEventForm,
        { FechasPersonalizadas: CustomDtsOrigin }: IEventForm,
        eventCfg: IEventoInfo,
        dtInicio: Date,
        varianteRecurrencia: CCalendarioTipoRecurrenciaMensual,
        fechaFinRecurrencia: string,
        tipoFinRecurrencia: CCalendarioFinRecurrencia,
        nRecurrencias: number,
        eventReference: IEventoPorCalendario
    ): IDatoBase[] {
        let editionOptions: IDatoBase[] = [];
        let calendarChanged = eventCfg.IdCalendario != (IdCalendarios as any as number);
        if (calendarChanged) return editionOptions;

        const turnOffRecurrency = TipoRecurrencia == Entidad.CCalendarioTipoRecurrencia.SinRecurrencia;
        const EventCfgRecEnd = eventCfg.FinRecurrencia
            ? (new DateV2(eventCfg.FinRecurrencia)._SetTimeZoneByIdSchool(eventReference.IdEscuela)._ToISOLocalString())
            : null;


        let recTypeChanged = eventCfg.TipoRecurrencia != TipoRecurrencia;
        let recVariantChanged = eventCfg.VarianteRecurrencia != varianteRecurrencia;
        let recEndTypeChanged = eventCfg.TipoFinRecurrencia != tipoFinRecurrencia;
        let nRecChanged = eventCfg.NRecurrencias != nRecurrencias;

        let recEndDateChanged = (() => {
            if (!eventCfg.FinRecurrencia && !fechaFinRecurrencia) return false;
            if ((eventCfg.FinRecurrencia && !fechaFinRecurrencia) || (!eventCfg.FinRecurrencia && fechaFinRecurrencia)) return true;
            return UIUtilTime._GetValidatorDateYMDV2(new Date(EventCfgRecEnd.replace("Z", ""))) != UIUtilTime._GetValidatorDateYMDV2(new DateV2(fechaFinRecurrencia.replace("Z", "")))
        })();

        let recCustomDtsChanged = TipoRecurrencia !== CCalendarioTipoRecurrencia.Libre
            ? false
            : EvalCustomDtsChanged(CustomDtsOrigin, FechasPersonalizadas)

        let recCfgChanged = recTypeChanged || recVariantChanged || recEndTypeChanged || nRecChanged || recEndDateChanged || recCustomDtsChanged;
        let dateWithoutTimeChanged = UIUtilTime._GetValidatorDateYMDV2(dtInicio) != UIUtilTime._GetValidatorDateYMDV2(new Date(eventReference.Inicio));

        let [optCurrentEvent, optThisAndNext, optAll] = [true, true, true];
        if ((recCfgChanged && dateWithoutTimeChanged) || turnOffRecurrency || calendarChanged || recCustomDtsChanged) {
            [optCurrentEvent, optThisAndNext, optAll] = [false, false, false];
        }
        if (recCfgChanged) optCurrentEvent = false;

        if (optCurrentEvent) editionOptions.push({ Id: CTipoAccionEvento.Unico, Name: _L("calendario.tag_current_event") });
        if (optAll) editionOptions.push({ Id: CTipoAccionEvento.Todos, Name: _L("calendario.tag_all_event") });

        return editionOptions
    }

    async function GetEventEditionType(editionOptions: IDatoBase[]) {
        let formEditionConfirm = new FormGenerator()._Crear({
            LabelMaxWidth: 130,
            schema: [
                {
                    model: "EditaConfig",
                    type: "radioList",
                    radioListAttr: {
                        ValueMember: "Id",
                        DisplayMember: "Name",
                        Data: editionOptions,
                        Direction: "vertical",
                        ReturnOnlyValueMember: true,
                        required: true,
                    }
                }
            ]
        }, { EditaConfig: editionOptions[0].Id })

        const confirm = await _ModalConfirmacionBasicoV2({
            Title: _L("c_actions.editar"),
            Width: 300,
            Content: formEditionConfirm._Form.node(),
        })

        let editionType: number = formEditionConfirm._Data.EditaConfig;

        return { confirm, editionType }
    }

    function RefreshDatePickerSelectionView(datesSelectionView: TSelectionHTML<"div">, data: number[]) {
        datesSelectionView.text(!data.length ? _L("calendario.tag_select_dates") : "");

        datesSelectionView.selectAll<HTMLDivElement, number>(":scope > .date_selected")
            .data(data)
            .join(
                enter => enter.append("div")
                    .classed("date_selected", true)
                    .text(d => UIUtilTime._DateFormatStandar(new Date(d), "dd/mm/yyyy")),
                update => update.text(d => UIUtilTime._DateFormatStandar(new Date(d), "dd/mm/yyyy")),
                exit => exit.remove()
            );
    }

    function RefreshStartDateViewAfterDatePickerSelect(datesTime: number[], originEventStart: string, form: FormGenerator<IEventForm>, isEdition: boolean) {
        let strDates = datesTime.map(d => UIUtilTime._FmtToInputDate(new Date(d)));

        if (isEdition) {
            let strEventDate = UIUtilTime._FmtToInputDate(originEventStart);
            let customDtPreserved = strDates.includes(strEventDate);
            let message = !customDtPreserved ? _L("calendario.input_mssg_date_rmv") : '';

            const FechaUnicaYMDCtrlWrapper = form._ControlsData.get("FechaUnicaYMD").controlWrapper;
            const FechaInicioYMDCtrlWrapper = form._ControlsData.get("FechaInicioYMD").controlWrapper;


            FechaUnicaYMDCtrlWrapper.select(":scope > div").classed("custom_dt_remove", !customDtPreserved);
            FechaInicioYMDCtrlWrapper.select(":scope > div").classed("custom_dt_remove", !customDtPreserved);
            FechaUnicaYMDCtrlWrapper.select(":scope > .free_recurrence_msg").text(message).classed("hide", customDtPreserved);
            FechaInicioYMDCtrlWrapper.select(":scope > .free_recurrence_msg").text(message).classed("hide", customDtPreserved);
        } else {
            if (strDates.length) {
                const FechaUnicaYMDInput = (form._ControlsData.get("FechaUnicaYMD").selection as TSelectionHTML<"input">).node();
                const FechaInicioYMDInput = (form._ControlsData.get("FechaInicioYMD").selection as TSelectionHTML<"input">).node();
                FechaInicioYMDInput && (FechaInicioYMDInput.value = strDates[0])
                FechaUnicaYMDInput && (FechaUnicaYMDInput.value = strDates[0]);
            }
        }
    }

    function FixDatesToCfg(fechasPersonalizadas: string[], startDate: Date, endDate: Date, isAllDay: boolean) {
        let firstDateSelection = new Date(fechasPersonalizadas.sort()[0].replace("Z", ""));
        let dtStart = new Date(firstDateSelection);
        dtStart.setHours(startDate.getHours());
        dtStart.setMinutes(startDate.getMinutes());
        dtStart.setSeconds(startDate.getSeconds());

        let dtEnd = new Date(dtStart);
        dtEnd.setHours(endDate.getHours());
        dtEnd.setMinutes(endDate.getMinutes());
        dtEnd.setSeconds(endDate.getSeconds());
        isAllDay && dtEnd.setDate(dtEnd.getDate() + 1)

        return { dtStart, dtEnd }
    }

    function GetRecurrenceTypes(dataForm: IEventForm) {
        let recurrenceTypesResult: IDatoBase[] = [];
        let recurrenceTypesInfo: { [k in Entidad.CCalendarioTipoRecurrencia]: IDatoBase } = {
            [Entidad.CCalendarioTipoRecurrencia.SinRecurrencia]: { Id: Entidad.CCalendarioTipoRecurrencia.SinRecurrencia, Name: _L("calendario.cal_tiporec_sin") },
            [Entidad.CCalendarioTipoRecurrencia.Diaria]: { Id: Entidad.CCalendarioTipoRecurrencia.Diaria, Name: _L("calendario.cal_tiporec_diaria") },
            [Entidad.CCalendarioTipoRecurrencia.Semanal]: { Id: Entidad.CCalendarioTipoRecurrencia.Semanal, Name: _L("calendario.cal_tiporec_semanal") },
            [Entidad.CCalendarioTipoRecurrencia.Mensual]: { Id: Entidad.CCalendarioTipoRecurrencia.Mensual, Name: _L("calendario.cal_tiporec_mensual") },
            [Entidad.CCalendarioTipoRecurrencia.Anual]: { Id: Entidad.CCalendarioTipoRecurrencia.Anual, Name: _L("calendario.cal_tiporec_anual") },
            [Entidad.CCalendarioTipoRecurrencia.Libre]: { Id: Entidad.CCalendarioTipoRecurrencia.Libre, Name: _L("calendario.cal_tiporec_libre") },
        };

        let countDays = GetDaysElapsedFromFormInputs(dataForm);
        if (countDays < 366)
            recurrenceTypesResult.push(recurrenceTypesInfo[CCalendarioTipoRecurrencia.Anual]);
        if (countDays < 29)
            recurrenceTypesResult.push(recurrenceTypesInfo[CCalendarioTipoRecurrencia.Mensual]);
        if (countDays < 8)
            recurrenceTypesResult.push(recurrenceTypesInfo[CCalendarioTipoRecurrencia.Semanal]);
        if (countDays < 2)
            recurrenceTypesResult.push(recurrenceTypesInfo[CCalendarioTipoRecurrencia.Diaria]);
        recurrenceTypesResult.push(recurrenceTypesInfo[CCalendarioTipoRecurrencia.SinRecurrencia])
        recurrenceTypesResult.reverse()
        recurrenceTypesResult.push(recurrenceTypesInfo[CCalendarioTipoRecurrencia.Libre])

        return recurrenceTypesResult;
    }
    function GetDaysElapsedFromFormInputs({ FechaInicioYMD, FechaFinYMD, IsAllDay }: IEventForm) {
        if (!IsAllDay) return 1;
        if (IsAllDay) return 1;
        if (!FechaInicioYMD || !FechaFinYMD) return 0;
        const dtInicio = new Date(`${FechaInicioYMD}T00:00`);
        const dtFin = new Date(`${FechaFinYMD}T00:00`);
        dtFin.setDate(dtFin.getDate() + 1);
        return CountDays(dtInicio, dtFin);
    }
    function CountDays(dtInicio: Date, dtFin: Date) {
        return UIUtilTime._GetTimeElapsedSimple(dtInicio, dtFin).Days();
    }

    type IMonthlyRecurrenceVariantOption = IDatoBase & { NDays?: number }
    function GetMonthlyRecurrenceVariantOptions({ TipoRecurrencia, IsAllDay, FechaInicioYMD, FechaUnicaYMD, HoraInicioHM }: IEventForm): IMonthlyRecurrenceVariantOption[] {
        const result: IMonthlyRecurrenceVariantOption[] = [];
        if (TipoRecurrencia != CCalendarioTipoRecurrencia.Mensual) {
            result.push({ Id: CCalendarioTipoRecurrenciaMensual.NoAplica, Name: "" });
            return result;
        }

        let strStartDate: string;
        if (IsAllDay) strStartDate = FechaInicioYMD + TIME_ZERO_STR;
        else strStartDate = FechaUnicaYMD + " " + HoraInicioHM;
        let startDate = new Date(strStartDate)
        let { isLast, nDay, weekDay } = GetDateMonthlyInfo(startDate)

        result.push({ Id: Entidad.CCalendarioTipoRecurrenciaMensual.LiteralDate, Name: _L("calendario.monthly_rec_literal", startDate.getDate()) })
        if (nDay != 5) {
            result.push({ Id: Entidad.CCalendarioTipoRecurrenciaMensual.NDay, Name: _L("calendario.monthly_rec_nday", ORDINAL_NUMBERS[nDay], UIUtilTime._GetDayName(weekDay, "long", false)), NDays: nDay })
        }
        if (!isLast) return result
        result.push({ Id: Entidad.CCalendarioTipoRecurrenciaMensual.LastDay, Name: _L("calendario.monthly_rec_lastday", UIUtilTime._GetDayName(weekDay, "long", false)) })
        return result
    }

    function GetDateMonthlyInfo(date: Date) {
        let weekDay = UIUtilTime._GetDayInWeek(date)

        let firstDayInMonth = new Date(date);
        firstDayInMonth.setDate(1);

        let lastDayInMonth = new Date(date)
        lastDayInMonth.setMonth(lastDayInMonth.getMonth() + 1);
        lastDayInMonth.setDate(0);

        let countDaysBf = 0;
        let auxEvalDate = new Date(date);
        auxEvalDate.setDate(auxEvalDate.getDate() - 7);
        while (auxEvalDate.getTime() >= firstDayInMonth.getTime()) {
            countDaysBf++;
            auxEvalDate.setDate(auxEvalDate.getDate() - 7);
        }

        let countDaysAf = 0;
        auxEvalDate = new Date(date);
        auxEvalDate.setDate(auxEvalDate.getDate() + 7);
        while (auxEvalDate.getTime() <= lastDayInMonth.getTime()) {
            countDaysAf++;
            auxEvalDate.setDate(auxEvalDate.getDate() + 7);
        }
        const isLast = countDaysAf == 0;
        const nDay = countDaysBf + 1

        return {
            isLast,
            nDay,
            weekDay
        }
    }

    function ValidateFormDateRange({ FechaInicioYMD, IsAllDay, HoraInicioHM, HoraFinHM, FechaUnicaYMD }: IEventForm) {
        if ((!FechaInicioYMD && IsAllDay) || (!IsAllDay && (!HoraInicioHM || !HoraFinHM))) {
            return false;
        }

        HoraInicioHM = IsAllDay ? "00:00" : HoraInicioHM;
        HoraFinHM = IsAllDay ? "00:00" : HoraFinHM;

        const dtInicio = new Date(`${IsAllDay ? FechaInicioYMD : FechaUnicaYMD}T${HoraInicioHM}`);
        const dtFin = new Date(`${IsAllDay ? FechaInicioYMD : FechaUnicaYMD}T${HoraFinHM}`);

        if (IsAllDay) {
            return dtFin.getTime() >= dtInicio.getTime();
        }
        return dtFin.getTime() > dtInicio.getTime();
    }

    export async function _GetEventInfoFromSv(event: IEventoPorCalendario): Promise<IEventoInfo> {
        const res = await _ObtenerConfiguracionInfo(event.Id, event.IdAgrupador);
        if (res.Resultado < 1) {
            return null;
        }

        return {
            ...res.Datos,
            FechasPersonalizadas: (
                res.Datos.TipoRecurrencia != CCalendarioTipoRecurrencia.Libre
                    ? []
                    : [
                        ...res.Datos.InicioHermanos.map(d => new DateV2(d)._SetTimeZoneByIdSchool(event.IdEscuela).toISOString()),
                        new Date(event.Inicio).toISOString()
                    ].sort()
            )
        }
    }

    export async function _OnAcceptEventAdd(formData: IEventForm, calendars: ICalendario[]) {
        let { dtInicio, dtFin } = GetStartAndEndDate(formData);
        const { fechaFinRecurrencia, nRecurrencias, tipoFinRecurrencia, varianteRecurrencia, fechasPersonalizadas } = GetRecurrenceInfo(formData);
        let calendariosInfo: ICalendariosToSend[] = calendars.map<ICalendariosToSend>(calendar => {
            return GetCalendarInfoToSend(calendar)
        })

        return await _AgregarEventos(
            {
                Nombre: formData.Nombre,
                IsAllDay: formData.IsAllDay,
                Inicio: new DateV2(dtInicio)._ToISOLocalString(),
                Fin: new DateV2(dtFin)._ToISOLocalString(),
                TipoRecurrencia: formData.TipoRecurrencia,
                FechasPersonalizadas: fechasPersonalizadas,
                VarianteRecurrencia: varianteRecurrencia,
                TipoFinRecurrencia: tipoFinRecurrencia,
                FinRecurrencia: fechaFinRecurrencia,
                NRecurrencias: nRecurrencias,
            },
            calendariosInfo
        )
    }

    export async function _OnAcceptEventEdition(
        { _Data: formData, _DataOrigin: dataOrigin }: FormGenerator<IEventForm>,
        eventInCalendar: IEventoPorCalendario,
        calendar: ICalendario,
        eventInfo: IEventoInfo,
    ) {
        let { dtInicio, dtFin } = GetStartAndEndDate(formData, (eventInCalendar.Inicio as any))
        let calendarioInfo = GetCalendarInfoToSend(calendar);
        const { varianteRecurrencia, fechaFinRecurrencia, tipoFinRecurrencia, nRecurrencias, fechasPersonalizadas } = GetRecurrenceInfo(formData);
        let editType = Entidad.CTipoAccionEvento.Unico;

        if (eventInCalendar.IdAgrupador != 0) {
            editType = Entidad.CTipoAccionEvento.Todos
            let editionOptions = GetEditionOptions(formData, dataOrigin, eventInfo, dtInicio, varianteRecurrencia, fechaFinRecurrencia, tipoFinRecurrencia, nRecurrencias, eventInCalendar)
            if (editionOptions.length) {
                let { confirm, editionType } = await GetEventEditionType(editionOptions);
                editType = editionType;
                if (!confirm || !editionType) {
                    if (!editionType) NotificacionV2._Mostrar(_L("calendario.notif_err_noedittype"), "ADVERTENCIA");
                    return;
                }
            }
        }

        let customDtsChange = false;
        if (
            formData.TipoRecurrencia == CCalendarioTipoRecurrencia.Libre
            && editType == CTipoAccionEvento.Todos
            && EvalCustomDtsChanged(dataOrigin.FechasPersonalizadas, formData.FechasPersonalizadas)
        ) {
            customDtsChange = true;
            let { dtStart, dtEnd } = FixDatesToCfg(fechasPersonalizadas, dtInicio, dtFin, formData.IsAllDay);
            dtInicio = dtStart;
            dtFin = dtEnd;
        }

        return await _EditarEvento({
            IdEvento: eventInCalendar.Id,
            TipoEdicion: editType,
            Nombre: formData.Nombre,
            IsAllDay: formData.IsAllDay,
            Inicio: new DateV2(dtInicio)._ToISOLocalString(),
            Fin: new DateV2(dtFin)._ToISOLocalString(),
            IdCalendario: formData.IdCalendarios as any,
            TipoRecurrencia: formData.TipoRecurrencia,
            VarianteRecurrencia: varianteRecurrencia,
            TipoFinRecurrencia: tipoFinRecurrencia,
            FinRecurrencia: fechaFinRecurrencia,
            NRecurrencias: nRecurrencias,
            IdKinder: calendarioInfo.IdKinder,
            IdEscolaridad: calendarioInfo.IdEscolaridad,
            IdGrupo: calendarioInfo.IdGrupo,
            TipoEvento: calendarioInfo.TipoEvento,
            IdEntidad: calendarioInfo.IdEntidad,
            FechasPersonalizadas: fechasPersonalizadas,

        }, customDtsChange)
    }

    /* FORM THINGS */
    export function _GetEventFormBuilded(
        actionPermission: (Entidad.CAccionPermiso.Agregar | Entidad.CAccionPermiso.Editar),
        evento: Partial<IEventoPorCalendario> = {},
        calendarsList: Entidad.ICalendario[],
        calendar: CalendarioGridV2,
    ) {
        let isEdition = actionPermission == Entidad.CAccionPermiso.Editar;
        let datePicker: InputDatePicker;
        const isNewEvent = !(evento?.Id);
        const form = new FormGenerator<IEventForm>();

        form._Crear({
            LabelMaxWidth: 130,
            schema: [
                { model: "Nombre", type: "input", labelText: _L("calendario.nombre"), inputAttr: { required: true } },
                { model: "IsAllDay", type: "input", labelText: _L("calendario.fullday"), inputAttr: { type: "checkbox", } },
                {
                    model: "FechaUnicaYMD", type: "input", labelText: _L("general.fecha"),
                    inputAttr: { required: true, type: "date", },
                    onLoad: (control) => {
                        control.controlWrapper.append("div").classed("free_recurrence_msg", true).classed("hide", true);
                    },
                },
                {
                    model: "FechaInicioYMD", type: "input", labelText: _L("calendario.start"),
                    onLoad: (control) => {
                        control.controlWrapper.append("div").classed("free_recurrence_msg", true).classed("hide", true);
                    },
                    onValidate: () => ValidateFormDateRange(form._Data),
                    inputAttr: {
                        required: true, type: "date", onchange: ({ target }) => {
                            const tipoRecM = (form._ControlsData.get("VarianteRecurrencia").instance as SelectV2);
                            tipoRecM._RefreshList();
                        }
                    }
                },
                { model: "HoraInicioHM", type: "input", labelText: _L("calendario.start"), inputAttr: { type: "time" }, onValidate: () => { return ValidateFormDateRange(form._Data) } },
                { model: "HoraFinHM", type: "input", labelText: _L("calendario.end"), inputAttr: { type: "time" } },
                {
                    model: "IdCalendarios", type: "selectMaterial",
                    labelText: _L("calendario.calendar"),
                    selectMaterialAttr: <IAtributosSelectMaterial<Entidad.ICalendario, "Id">>{
                        Data: calendarsList
                            .filter(d => UIUtilPermission._HasAccionPermission(actionPermission, ModuloCalendario, d.IdEscuela))
                            .sort((a, b) => a.TipoEntidad - b.TipoEntidad)
                            .sort((a, b) => a.IdEscuela - b.IdEscuela),
                        required: true,
                        valueMember: "Id",
                        displayMember: "Nombre",
                        multiselect: isNewEvent,
                        OnStepItemListUI: (container, dato: Entidad.ICalendario) => {
                            container.html("");
                            let colorCalendar = calendar._GetCalendarColor(dato.Id);
                            let isSchool = dato.TipoEntidad == CCalendarioTipoEntidad.Escuela;
                            let schoolName = DataModuloMain._GetDataValueFieldByName("Escuela", dato.IdEscuela, "Nombre") || "No Disponible";

                            let calendarContainer = container.append("div").classed("cal_cont", true);
                            calendarContainer.append("b").classed("color", true).style("background-color", colorCalendar);
                            let calendarInfo = calendarContainer.append("div").classed("cal_info", true);
                            calendarInfo.append("div").text(dato.Nombre).classed("is_school", isSchool);

                            if (!isSchool) {
                                calendarInfo.append("label").classed("school_aux", true).text(schoolName)
                            }
                            calendarContainer.append("div").text(UIUtilViewData._GetStr_CalTipoEntidad(dato.TipoEntidad))
                        },
                        ShowAndEnableSearchText: true,
                        OnChangeSearchText_GetDataValueToEval: (d: Entidad.ICalendario) => d.TipoEntidad == CCalendarioTipoEntidad.Escuela
                            ? d.Nombre
                            : d.Nombre + (_DICC_ESCUELA.get(d.IdEscuela)?.Nombre || ""),
                    }
                },
                {
                    model: "TipoRecurrencia", type: "selectMaterial", labelText: _L("calendario.tiporecurrencia"),
                    selectMaterialAttr: {
                        valueMember: "Id",
                        displayMember: "Name",
                        required: true,
                        Data: () => GetRecurrenceTypes(form._Data),
                        onChange: () => {
                            let dataForm = form._Data;
                            let dtInicio = new Date((dataForm.IsAllDay ? dataForm.FechaInicioYMD : dataForm.FechaUnicaYMD) + " ");
                            let nRec = 0;
                            const tipoRec = dataForm.TipoRecurrencia;
                            if (!isEdition) { datePicker.setDate([]); };

                            switch (tipoRec) {
                                case CCalendarioTipoRecurrencia.Diaria:
                                    dtInicio.setMonth(dtInicio.getMonth() + 1)
                                    dtInicio.setDate(dtInicio.getDate() - 1)
                                    nRec = 30;
                                    break;
                                case CCalendarioTipoRecurrencia.Semanal:
                                    dtInicio.setMonth(dtInicio.getMonth() + 3)
                                    nRec = 13
                                    break;
                                case CCalendarioTipoRecurrencia.Mensual:
                                    dtInicio.setMonth(dtInicio.getMonth() + 12)
                                    nRec = 12;
                                    break;
                                case CCalendarioTipoRecurrencia.Anual:
                                    dtInicio.setFullYear(dtInicio.getFullYear() + 5)
                                    nRec = 5;
                                    break;
                                case CCalendarioTipoRecurrencia.Libre:
                                    if (!isEdition) break;
                                    let FechaInicioYMDInput = (form._ControlsData.get("FechaInicioYMD").selection as TSelectionHTML<"input">).node();
                                    FechaInicioYMDInput && (FechaInicioYMDInput.value = form._DataOrigin.FechaInicioYMD);

                                    let FechaUnicaYMDInput = (form._ControlsData.get("FechaUnicaYMD").selection as TSelectionHTML<"input">).node();
                                    FechaUnicaYMDInput && (FechaUnicaYMDInput.value = form._DataOrigin.FechaInicioYMD);
                                    break;
                            }

                            form._ControlsData.get("FechaInicioYMD").selection.property("disabled", (tipoRec == CCalendarioTipoRecurrencia.Libre));
                            form._ControlsData.get("FechaUnicaYMD").selection.property("disabled", (tipoRec == CCalendarioTipoRecurrencia.Libre));

                            switch (dataForm.TipoFinRecurrencia) {
                                case CCalendarioFinRecurrencia.Fecha:
                                    let nRecurrences = form._ControlsData.get("NRecurrencias").row.select<HTMLInputElement>("#NRecurrencias").node();
                                    nRecurrences.value = nRec + "";
                                    break;
                                case CCalendarioFinRecurrencia.Numero:
                                    const dtFinRec = form._ControlsData.get("FechaFinRecurrenciaYMD").row.select<HTMLInputElement>("#FechaFinRecurrenciaYMD").node();
                                    dtFinRec.value = UIUtilTime._FmtToInputDate(dtInicio)
                                    break;
                            }
                        },
                        onSelect: (data: IDatoBase) => {
                            form._ControlsData.get("FechaInicioYMD").selection.property("disabled", (data?.Id == Entidad.CCalendarioTipoRecurrencia.Libre));
                            form._ControlsData.get("FechaUnicaYMD").selection.property("disabled", (data?.Id == Entidad.CCalendarioTipoRecurrencia.Libre));
                            const tipoRecM = (form._ControlsData.get("VarianteRecurrencia").instance as SelectV2);
                            tipoRecM._RefreshList();
                            if (data?.Id != Entidad.CCalendarioTipoRecurrencia.Mensual) {
                                tipoRecM._valueSelect(Entidad.CCalendarioTipoRecurrenciaMensual.NoAplica);
                            }
                        }
                    }
                },
                {
                    model: "FechasPersonalizadas", type: "unknown", labelText: _L("calendario.lbl_date_selection"),
                    onLoad: ({ controlWrapper }) => {
                        let inputDatePickerContainer = controlWrapper.append("div").classed("contenedor_combo", true);
                        let datesSelection = inputDatePickerContainer.append("div").style("flex", "1").text(_L("calendario.tag_select_dates"));
                        datePicker = new InputDatePicker({
                            Mode: "multiselect",
                            Element: inputDatePickerContainer.node(),
                            Lang: 'es',
                            ButtonsText: { apply: _L("general.aplicar"), cancel: _L("general.cancelar") },
                            NumberOfColumns: 2,
                            NumberOfMonths: 2,
                            Position: "top",
                            TooltipText: { many: _L("calendario.lbl_dates"), one: _L("calendario.lbl_date"), other: _L("calendario.lbl_dates") },
                            MultiselectDatePickerAttrs: {
                                multiselect: { max: null }
                            },
                            OnSelect(data) {
                                RefreshDatePickerSelectionView(datesSelection, data);
                                RefreshStartDateViewAfterDatePickerSelect(data, evento?.Inicio, form, isEdition);
                            },
                        })
                    },
                    unknowAttrs: { required: true },
                    onGetFixedValue: () => {
                        let val = datePicker.getDateISOValue();
                        return val;
                    },
                    onValidate: (dato) => {
                        return !!dato?.length;
                    },
                },
                {
                    model: "TipoFinRecurrencia", type: "radioList", labelText: _L("calendario.finaliza"),
                    radioListAttr: {
                        ValueMember: "Id",
                        DisplayMember: "Name",
                        ReturnOnlyValueMember: true,
                        required: true,
                        Data: <IDatoBase[]>[
                            { Id: Entidad.CCalendarioFinRecurrencia.Fecha, Name: _L("calendario.finaliza_fecha") },
                            { Id: Entidad.CCalendarioFinRecurrencia.Numero, Name: _L("calendario.finaliza_max") },
                        ],
                        Direction: "vertical",
                        OnStepItemUI: (container, _, d: IDatoBase) => setTimeout(() => {
                            if (d.Id == Entidad.CCalendarioFinRecurrencia.Fecha)
                                container.append(() => form._ControlsData.get("FechaFinRecurrenciaYMD").row.node())
                            else if (d.Id == Entidad.CCalendarioFinRecurrencia.Numero)
                                container.append(() => form._ControlsData.get("NRecurrencias").row.node())
                        })
                    }
                },
                {
                    model: "FechaFinRecurrenciaYMD", type: "input", inputAttr: { type: "date" },
                    onValidate: (val) => {
                        let dataFrm = form._Data;
                        let conRecurrencia = dataFrm.TipoRecurrencia != Entidad.CCalendarioTipoRecurrencia.SinRecurrencia;
                        let tipoReqFecha = dataFrm.TipoFinRecurrencia == Entidad.CCalendarioFinRecurrencia.Fecha;
                        if (!conRecurrencia || !tipoReqFecha) return true;
                        if (!dataFrm.FechaFinRecurrenciaYMD) return false;
                        else if (!isNewEvent) return true
                        let dt = new Date(`${val}T00:00`);
                        let dtFin = new Date(`${dataFrm.IsAllDay ? dataFrm.FechaInicioYMD : dataFrm.FechaUnicaYMD}T00:00`);
                        return dt.getTime() >= dtFin.getTime();
                    }
                },
                {
                    model: "NRecurrencias", type: "input", inputAttr: { type: "number" }, labelText: _L("calendario.recurrencias"),
                    onValidate: (val, control) => {
                        let dataFrm = form._Data;
                        let conRecurrencia = dataFrm.TipoRecurrencia != Entidad.CCalendarioTipoRecurrencia.SinRecurrencia;
                        let tipoReqNumero = dataFrm.TipoFinRecurrencia == Entidad.CCalendarioFinRecurrencia.Numero;
                        if (!conRecurrencia || !tipoReqNumero) return true;
                        return val > 0
                    },
                },
                {
                    model: "VarianteRecurrencia", type: "selectMaterial", labelText: _L("calendario.tiporecurrenciamensual"),
                    selectMaterialAttr: {
                        valueMember: "Id",
                        displayMember: "Name",
                        required: true,
                        Data: () => GetMonthlyRecurrenceVariantOptions(form._Data),
                    }
                },
            ],
            OnAssignData: (data) => {
                if (!data) return;
                if (data.TipoRecurrencia == Entidad.CCalendarioTipoRecurrencia.Libre) {
                    datePicker.setDate(data.FechasPersonalizadas.map(d => new Date(d)))
                } else {
                    if (data.FechaInicioYMD || data.FechaUnicaYMD) {
                        datePicker.goToDate(new Date(`${(data.FechaInicioYMD ?? data.FechaUnicaYMD)} 00:00`))
                    }
                }
            },
            BuildView: (container, controlsForm, form) => {
                form._Form.classed("calendarios_form_event", true);
                container.append(() => controlsForm.get("Nombre").row.node());

                container.append(() => controlsForm.get("IsAllDay").row.node());

                container.append(() => controlsForm.get("FechaUnicaYMD").row.node());

                container.append(() => controlsForm.get("FechaInicioYMD").row.node())
                container.append(() => controlsForm.get("HoraInicioHM").row.node())

                container.append(() => controlsForm.get("HoraFinHM").row.node())

                container.append(() => controlsForm.get("IdCalendarios").row.node());

                container.append("div").attr("class", "row").append("b").text(_L("calendario.recurrencia"));
                container.append(() => controlsForm.get("TipoRecurrencia").row.node());
                container.append(() => controlsForm.get("FechasPersonalizadas").row.node());
                container.append(() => controlsForm.get("VarianteRecurrencia").row.node());
                container.append(() => controlsForm.get("TipoFinRecurrencia").row.node());
            },
        })

        return form;
    }

    export function _AssignDataToForm(
        form: FormGenerator,
        calendar: CalendarioGridV2,
        eventData: Partial<IEventoPorCalendario>,
        eventInfo?: Entidad.IEventoInfo,
    ): void {
        let eventFormData: Partial<IEventForm>;
        if (!eventData.Id) {
            let [focusDateA, focusDateB] = (() => {
                if (eventData.Inicio) {
                    return [new Date(eventData.Inicio), new Date(eventData.Fin)];
                }
                let now = new Date();
                let dtFocused = calendar._GetFocusDate();
                let dtFocusedTimeNow = new Date(dtFocused);
                dtFocusedTimeNow.setHours(now.getHours(), now.getMinutes());

                let dtTimeNearest = new Date(dtFocusedTimeNow);
                dtTimeNearest.setMinutes(dtTimeNearest.getMinutes() + 30);

                if (dtTimeNearest.getDate() != dtFocusedTimeNow.getDate()) {
                    dtTimeNearest = dtFocusedTimeNow;
                }

                let dtInicio = new Date(dtTimeNearest);
                dtInicio.setHours(dtInicio.getHours(), 0, 0, 0);
                let dtFin = new Date(dtInicio);
                dtFin.setHours(dtInicio.getHours() + 1);

                if (dtInicio.getDate() != dtFin.getDate()) dtFin.setMinutes(dtFin.getMinutes() - 1)
                return [dtInicio, dtFin];
            })();

            let recurrenceEnd = (() => {
                let dt = new Date(focusDateB);
                dt.setMonth(dt.getMonth() + 2);
                return dt;
            })();

            let idCalendar = calendar._GetCalendarsSelected()
                .sort((a, b) => Number(a.IdGrupo) - Number(b.IdGrupo))[0]?.Id || 0;
            eventFormData = {
                ...eventData,
                IdCalendarios: eventData?.IdCalendario ? [eventData.IdCalendario] : [idCalendar],
                TipoRecurrencia: CCalendarioTipoRecurrencia.SinRecurrencia,
                VarianteRecurrencia: CCalendarioTipoRecurrenciaMensual.NoAplica,
                FechaFinRecurrenciaYMD: UIUtilTime._FmtToInputDate(recurrenceEnd),
                NRecurrencias: 2,
                TipoFinRecurrencia: Entidad.CCalendarioFinRecurrencia.Fecha,
                FechaUnicaYMD: UIUtilTime._FmtToInputDate(focusDateA),
                FechaInicioYMD: UIUtilTime._FmtToInputDate(focusDateA),
                HoraInicioHM: UIUtilTime._FmtToInputTime(focusDateA),
                FechaFinYMD: UIUtilTime._FmtToInputDate(focusDateB),
                HoraFinHM: UIUtilTime._FmtToInputTime(focusDateB),
                IsAllDay: false,
            }

            form._AsignaData(eventFormData);
            return
        }

        eventFormData = {
            Nombre: eventData.Nombre,
            IdCalendarios: [eventData.IdCalendario],
            TipoRecurrencia: Entidad.CCalendarioTipoRecurrencia.SinRecurrencia,
            VarianteRecurrencia: Entidad.CCalendarioTipoRecurrenciaMensual.NoAplica,
            TipoFinRecurrencia: Entidad.CCalendarioFinRecurrencia.Fecha,
            FechaFinRecurrenciaYMD: null,
            NRecurrencias: null,
            IsAllDay: (UIUtilTime._GetTimeElapsedSimple(new Date(eventData.Inicio), new Date(eventData.Fin)).Hours() == 24),
            ReferenceBlock: eventData.BlockReference
        }

        if (eventInfo) {
            eventFormData.TipoRecurrencia = eventInfo.TipoRecurrencia;
            eventFormData.VarianteRecurrencia = eventInfo.VarianteRecurrencia;
            eventFormData.TipoFinRecurrencia = eventInfo.TipoFinRecurrencia;
            eventFormData.FechaFinRecurrenciaYMD = UIUtilTime._FmtToInputDate(eventInfo.FinRecurrencia, eventData.IdEscuela);
            eventFormData.NRecurrencias = eventInfo.NRecurrencias;
            eventFormData.FechasPersonalizadas = eventInfo.FechasPersonalizadas
        }

        if (eventFormData.ReferenceBlock) {
            eventFormData.FechaInicioYMD = UIUtilTime._FmtToInputDate(eventFormData.ReferenceBlock.Inicio);
            let end = new Date(eventFormData.ReferenceBlock.Fin);
            end.setDate(end.getDate() - 1);
            eventFormData.FechaFinYMD = UIUtilTime._FmtToInputDate(end);
        } else {
            eventFormData.FechaInicioYMD = UIUtilTime._FmtToInputDate(eventData.Inicio);
            eventFormData.FechaFinYMD = UIUtilTime._FmtToInputDate(eventData.Inicio);
        }

        eventFormData.FechaUnicaYMD = UIUtilTime._FmtToInputDate(eventData.Inicio);
        eventFormData.HoraInicioHM = !eventFormData.IsAllDay
            ? UIUtilTime._FmtToInputTime(new Date(eventData.Inicio))
            : "10:00";
        eventFormData.HoraFinHM = !eventFormData.IsAllDay
            ? UIUtilTime._FmtToInputTime(new Date(eventData.Fin))
            : "10:30";
        form._AsignaData(eventFormData);
        return
    }

    export function _GetDeleteEventForm(event: IEventoPorCalendario, formContainter: TSelectionHTML<"div">, groupedEvents: IEventoPorCalendario[]) {
        let siblingEvents = groupedEvents.filter(d => d.Id != event.Id)
        let siblingFutureEvents = siblingEvents.filter(d => d.Inicio >= (event.Inicio as unknown as Date).toISOString());

        siblingEvents.length && formContainter.append("p")
            .text(`${_L("calendario.tag_recurrent_event")}`)
            .style("margin-top", "var(--padding2)")
            .style("margin-bottom", "var(--padding2)");

        let deleteOpts = <IDatoBase[]>[
            { Id: CTipoAccionEvento.Unico, Name: _L("calendario.tag_current_event") }
        ]

        siblingFutureEvents.length && deleteOpts.push({ Id: Entidad.CTipoAccionEvento.Futuros, Name: _L("calendario.tag_current&future_event") })
        siblingEvents.length && deleteOpts.push({ Id: Entidad.CTipoAccionEvento.Todos, Name: _L("calendario.tag_all_event") })

        return (
            new FormGenerator()._Crear(
                {
                    LabelMaxWidth: 130,
                    schema: [
                        {
                            model: "EliminaConfig",
                            type: "radioList",
                            radioListAttr: {
                                ValueMember: "Id",
                                DisplayMember: "Name",
                                Data: deleteOpts,
                                Direction: "vertical",
                                ReturnOnlyValueMember: true,
                                required: true,
                                Disabled: !siblingEvents.length
                            }
                        }
                    ]
                }, { EliminaConfig: CTipoAccionEvento.Unico }
            )
        )
    }
}